module.exports = __webpack_public_path__ + "img/norway-ill-defined-causes-female.dbf3f183.png";